import { configureStore } from "@reduxjs/toolkit";
import getTicketReducer from "./Slice/getTicket";
import ThemeReducer from './Slice/themeSlice'
import getLoginReducer from './Slice/loginUser'
import ProfileReducer from "./Slice/getprofile";
import CourseReducer from "./Slice/getCourses";
import ClassroomReducer from "./Slice/getClassroom";
import MyCourseReducer from "./Slice/myCourses";
import DashboardStatusReducer from "./Slice/Org/Dasbhaord/status"
import getOrgProfileReducer from "./Slice/Org/getprofile";
import getQuiriesReducer from "./Slice/Org/Dasbhaord/getQuiries";
import PerformanceReducer from "./Slice/Org/Dasbhaord/getPerformance";
import getCourseslistReducer from "./Slice/Org/Courses/getCourseslist";
import pendingCourselistReducer from './Slice/Org/Courses/pendingCoursesList';
import getModuleReducer from "./Slice/Org/Courses/getModule";
import orgClassReducer from "./Slice/Org/Class/getClasses";
import LiveClassReducer from "./Slice/Org/Class/getLiveClass";
import AllUserReducer from "./Slice/Org/management/getUsers";

const store = configureStore({
  reducer: {
    user_tickets: getTicketReducer,
    theme: ThemeReducer,
    login_user: getLoginReducer,
    profile_data: ProfileReducer,
    getCourses: CourseReducer,
    getClassroom: ClassroomReducer,
    getMyCourses: MyCourseReducer,

    // organization
    getStatus: DashboardStatusReducer,
    getQueiry: getQuiriesReducer,
    getPerfromance: PerformanceReducer,
    getprofile: getOrgProfileReducer,
    getcourselist: getCourseslistReducer,
    getpendingCourseList: pendingCourselistReducer,
    getmodule: getModuleReducer,
    getOrgClasses: orgClassReducer,
    getLiveClass: LiveClassReducer,
    getAllUsers: AllUserReducer,
  },
});

export default store;